'use client';

import React, { useState } from "react";
import "./your-privacy-choices.modules.css";
import Footer from "@components/footer/Footer";
import Navbar from "@components/Navbar";
const YourPrivacyChoices = () => {
  // State for checkboxes
  const [optOutSaleShare, setOptOutSaleShare] = useState(false);
  const [rejectCookies, setRejectCookies] = useState(false);

  // Handlers for checkboxes
  const handleOptOutChange = () => {
    setOptOutSaleShare(!optOutSaleShare);
  };

  const handleRejectCookiesChange = () => {
    setRejectCookies(!rejectCookies);
  };

  // Placeholder function for saving settings
  const handleSaveSettings = (settingType) => {
    alert(`${settingType} settings saved.`);
  };

  return (
    <div>
      <Navbar />
      {/* Header Section */}
      <header className="page-header">
        <h1>Your Privacy Choices</h1>
        <p>Control how your data is shared, sold, or used for personalized ads and cookies.</p>
      </header>

      {/* Main Content */}
      <main className="content-container">
        {/* Personalized Ad Settings */}
        <section className="ad-settings">
          <h2>Personalized Ad Settings</h2>
          <h3>Opt out of selling, sharing and targeted advertising</h3>
          <p>
            We do not sell personal information to third parties—we’re not a data broker 
            and we don’t put personal information on the open market. However, we may share 
            personal information with certain third parties to provide and improve our services.
          </p>
          <p>
            For example, we ask for your learner’s name so that teachers can properly address 
            them in class. We also share information about the classes you express an interest 
            in so we can show you more relevant classes as advertisements on other web pages. 
            This sharing of data with certain third parties may be considered a “sale,” “sharing,” 
            or “targeted advertising” under California and certain other state privacy laws.
          </p>
          <p>
            If you’re a U.S. user and want to opt out of such data sharing, you can do so 
            by checking the box below and saving your selection.
          </p>

          {/* Opt-out Checkbox & Button */}
          <div className="option-group">
            <label htmlFor="optOutSaleShare" className="checkbox-label">
              <input 
                type="checkbox" 
                id="optOutSaleShare" 
                name="optOutSaleShare" 
                checked={optOutSaleShare} 
                onChange={handleOptOutChange} 
              />
              Do not sell or share my personal information
            </label>
            <button className="save-button" onClick={() => handleSaveSettings("Ad")}>
              Save Ad Settings
            </button>
          </div>
        </section>

        {/* Cookie Settings */}
        <section className="cookie-settings">
          <h2>Cookie Settings</h2>
          <h3>Reject extra cookies</h3>
          <p>
            We use cookies to make our site better. Some cookies are necessary, 
            but having extra cookies lets us personalize your experience. 
            Read our <a href="#">cookie policy</a>.
          </p>

          {/* Opt-out Checkbox & Button */}
          <div className="option-group">
            <label htmlFor="rejectCookies" className="checkbox-label">
              <input 
                type="checkbox" 
                id="rejectCookies" 
                name="rejectCookies" 
                checked={rejectCookies} 
                onChange={handleRejectCookiesChange} 
              />
              Reject extra cookies
            </label>
            <button className="save-button" onClick={() => handleSaveSettings("Cookie")}>
              Save Cookie Settings
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default YourPrivacyChoices;
